import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.002 10C20.002 15.5228 15.5248 20 10.002 20C4.47911 20 0.00195312 15.5228 0.00195312 10C0.00195312 4.47715 4.47911 0 10.002 0C15.5248 0 20.002 4.47715 20.002 10ZM2.50195 10C2.50195 14.1421 5.85982 17.5 10.002 17.5C14.1441 17.5 17.502 14.1421 17.502 10C17.502 5.85786 14.1441 2.5 10.002 2.5C5.85982 2.5 2.50195 5.85786 2.50195 10Z",
      fill: "#EDEDED"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.99805 0C11.3113 0 12.6116 0.258658 13.8249 0.761205C15.0381 1.26375 16.1405 2.00035 17.0691 2.92893C17.9977 3.85752 18.7343 4.95991 19.2368 6.17317C19.7394 7.38642 19.998 8.68678 19.998 10C19.998 11.3132 19.7394 12.6136 19.2368 13.8268C18.7343 15.0401 17.9977 16.1425 17.0691 17.0711C16.1405 17.9997 15.0381 18.7362 13.8249 19.2388C12.6116 19.7413 11.3113 20 9.99805 20L9.99805 17.5C10.983 17.5 11.9582 17.306 12.8682 16.9291C13.7781 16.5522 14.6049 15.9997 15.3013 15.3033C15.9978 14.6069 16.5502 13.7801 16.9271 12.8701C17.3041 11.9602 17.498 10.9849 17.498 10C17.498 9.01509 17.3041 8.03982 16.9271 7.12987C16.5502 6.21993 15.9978 5.39314 15.3013 4.6967C14.6049 4.00026 13.7781 3.44781 12.8682 3.0709C11.9582 2.69399 10.983 2.5 9.99805 2.5V0Z",
      fill: "#489ffa"
    }, null, -1)
  ])))
}
export default { render: render }